import baseInitState from 'src/helpers/redux/baseInitState'
import baseReducer from 'src/helpers/redux/baseReducer'

import { actionType } from './event-participant.action'

const initState = {
  ...baseInitState,
}

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actionType('markPresence').request:
      return {
        ...state,
        isLoadingSubmit: true,
      }
    case actionType('markPresence').success:
    case actionType('markPresence').error:
      return {
        ...state,
        isLoadingSubmit: false,
      }

    default:
      return baseReducer(state, action, actionType)
  }
}
